/* eslint-disable no-unused-vars */
import { unitType } from "../../../util/unitType";

const PERCENTAGE_FEATURE = ["AromaticsW",
    "Aromatics1ringIP391W",
    "Aromatics2ringIP391W",
    "Aromatics3ringIP391W",
    "AromaticsUVW",
    "AromaticsPyrenesUVW",
    "AromaticsIP391W",
    "Aromatics1ringUVW",
    "Aromatics2ringUVW",
    "Aromatics3ringUVW",
    "Aromatics4ringUVW",
    "Aromatics5ringUVW",
    "Aromatics6ringUVW",
    "Aromatics7ringUVW",
    "Ash",
    "AsphaltenesC5",
    "Carbon",
    "CarbonResidueRamsbottom",
    "CarbonResidueMCRT",
    "Hydrogen",
    "NaphthenesW",
    "NaphthalenesW",
    "Nickel",
    "Nitrogen",
    "NitrogenBasic",
    "NonVolatileCokeNVC",
    "NParaffinsW",
    "ParaffinsW",
    "Sodium",
    "Sulphur",
    "SulphurMercaptan",
    "Vanadium",
    "Wax",
    "WaxCOED",
    "SG_CH4",
    "SG_Carbondioxide",
    "SG_Hydrogen",
    "SG_H2O",
    "SG_CarbonMonoxide",
    "HCU_H2S_Percent",
    "HCU_Frac_Drum_Level",
    "HCU_Sulfur",
    "HCUSulfurBottom",
    "HCU_Total_Sulfur",
    "HCU_Fract_Feed_Sulfur",
    "HCU_NH4HS_Dep_Rate"];

export const getNameUnits = (name, index, units, precentageFeature) => {
    switch (name) {
        case "DensityLastMonth":
        case "DensityLastWeek":
        case "Density":
            return `${name}[${unitType(units, "density", "ui")}]`;
        case "AnilinePointC":
        case "CloudPointC":
        case "FlashPointC":
        case "FreezePointC":
        case "PourPointC":
        case "SofteningPointC":
        case "Temperature":
        case "TemperatureLastWeek":
        case "NominalTemperature":
        case "HCU_Temperature":
        case "HCU_Fractionator_Temp":
        case "HCU_H2_tube_temp":
        case "HCU_Water_Pump_Temp":
        case "HCU_Outlet_Temp":
        case "HCU_Reactor_Temp":
        case "HCU_Heater_Outlet_temp":
        case "HCU_Stack_Temp_B":
        case "HCU_Tubeskin_temp":
        case "HCU_Lean_Amine_A":
        case "HCU_Lean_Amine_B":
        case "HCU_Stack_Temp_A":
        case "HCU_REAC_Outlet_Temp":
        case "HCU_HPS_Temp":
        case "HCU_Skin_Temp":
        case "HCU_Feed_Outlet_temp":
        case "HCU_Feed_Drum_Temp":
        case "HCU_Heater_stack_temp":
        case "HCU_Preheat_Temp":
        case "HCU_Temp_Bottoms_A":
        case "HCU_Temp_Bottoms_B":
        case "HCU_Feed_Inlet_temp_Frac":
        case "HCU_Frac_Dew_Point":
        case "HCU_NH4Cl_Rate":
        case "AmbientTemp":
            return `${name}[${unitType(units, "temperature", "ui")}]`;
        case "DewPoint":
            return `Aqueous dew point (overhead vapors)[${unitType(units, "temperature", "ui")}]`
        case "DeltaT":
            return `TCR vs. aq. dew point (overhead vapors)[${unitType(units, "temperature", "ui")}]`
        case "Throughput":
            return `${name}[${unitType(units, "cubic length", "ui")}/h]`;
        case "ViscosityLastMonth":
        case "Viscosity":
            return `${name}[${unitType(units, "square length", "ui")}/s]`;
        case "NominalVelocity":
        case "VelocityLastMonth":
        case "SG_Velocity":
        case "Velocity":
            return `${name}[${unitType(units, "longlength", "ui")}/s]`;
        case "PipeDiameter":
        case "SmokePointm":
            return `${name}[${unitType(units, "longlength", "ui")}]`;
        case "AromaticsW":
        case "Aromatics1ringIP391W":
        case "Aromatics2ringIP391W":
        case "Aromatics3ringIP391W":
        case "AromaticsUVW":
        case "AromaticsPyrenesUVW":
        case "AromaticsIP391W":
        case "Aromatics1ringUVW":
        case "Aromatics2ringUVW":
        case "Aromatics3ringUVW":
        case "Aromatics4ringUVW":
        case "Aromatics5ringUVW":
        case "Aromatics6ringUVW":
        case "Aromatics7ringUVW":
        case "Ash":
        case "AsphaltenesC5":
        case "Carbon":
        case "CarbonResidueRamsbottom":
        case "CarbonResidueMCRT":
        case "Hydrogen":
        case "NaphthenesW":
        case "NaphthalenesW":
        case "Nickel":
        case "Nitrogen":
        case "NitrogenBasic":
        case "NonVolatileCokeNVC":
        case "NParaffinsW":
        case "ParaffinsW":
        case "Sodium":
        case "Sulphur":
        case "SulphurMercaptan":
        case "Vanadium":
        case "Wax":
        case "WaxCOED":
        case "SG_CH4":
        case "SG_Carbondioxide":
        case "SG_Hydrogen":
        case "SG_H2O":
        case "SG_CarbonMonoxide":
        case "HCU_H2S_Percent":
        case "HCU_Frac_Drum_Level":
        case "HCU_Sulfur":
        case "HCUSulfurBottom":
        case "HCU_Total_Sulfur":
        case "HCU_Fract_Feed_Sulfur":
        case "HCU_NH4HS_Dep_Rate":
            precentageFeature.push(name);
            return `${name}[%]`;
        case "NominalPressure":
        case "Pressure":
        case "ReidVapourPressurePsi":
        case "SG_Pressure":
        case "HCU_H2_Partial_Pressure":
        case "HCU_Tube_Side_dP":
            return `${name}[${unitType(units, "pressure", "ui")}]`;
        case "TanMgKOHg":
        case "HCU_Naphthenic_Acid":
            return `${name}[mgKOH/g]`;
        case "HCU_Water_Wash_Flow_Rate":
        case "HCU_Water_Inj_Rate":
            return `${name}[${unitType(units, "volume", "ui")}/min]`;
        case "HCU_Oil_Flow":
        case "HCU_Naptha_Flow":
            return `${name}[Mbbl/day]`;
        case "HCU_Inorganic_Chloride":
            return `${name}[mg/${unitType(units, "volume", "ui")}]`;
        case "HCU_Hydrogen_Flow":
        case "HCU_H2_Flow":
            return `${name}[${unitType(units, "cubic length", "ui")}/day]`;
        case "HCU_Nitrogen":
        case "HCU_Total_Nitrogen":
            return `${name}[ppm]`;
        case "HCU_Rich_Amine":
            return `${name}`;
        case "HCU_Sour_H2O_Chlorides":
            return `${name}[mg/L]`;
        case "SG_H2S":
            return `${name}[PPBV]`;
        case "NaClContent":
        case "ChlorideContent":
        case "NaOHConc":
        case "NH4Content":
        case "FEContent":
            return `${name}[ppmw]`
        case "AmineDosingRate":
            return `${name}[l/h]`
        case "H2OContent":
            return `${name}[wt%]`
        case "Sulphur_O3":
            return "Residual_S03"
        case "DISS_O":
            return "Dissolved Oxygen"
        case "Water":
            return "Prod_Injectedwater/day"
        case "Liquid":
            return "Oxy-Scav_LPD"
        default:
            return name;
    }
};

export const getImperialOnValue = (name, value) => {
    switch (name) {
        case "DensityLastMonth":
        case "DensityLastWeek":
        case "Density":
            return value * 8.354;
        case "AnilinePointC":
        case "CloudPointC":
        case "FlashPointC":
        case "FreezePointC":
        case "PourPointC":
        case "SofteningPointC":
        case "Temperature":
        case "TemperatureLastWeek":
        case "NominalTemperature":
        case "HCU_Temperature":
        case "HCU_Fractionator_Temp":
        case "HCU_H2_tube_temp":
        case "HCU_Water_Pump_Temp":
        case "HCU_Outlet_Temp":
        case "HCU_Reactor_Temp":
        case "HCU_Heater_Outlet_temp":
        case "HCU_Stack_Temp_B":
        case "HCU_Tubeskin_temp":
        case "HCU_Lean_Amine_A":
        case "HCU_Lean_Amine_B":
        case "HCU_Stack_Temp_A":
        case "HCU_REAC_Outlet_Temp":
        case "HCU_HPS_Temp":
        case "HCU_Skin_Temp":
        case "HCU_Feed_Outlet_temp":
        case "HCU_Feed_Drum_Temp":
        case "HCU_Heater_stack_temp":
        case "HCU_Preheat_Temp":
        case "HCU_Temp_Bottoms_A":
        case "HCU_Temp_Bottoms_B":
        case "HCU_Feed_Inlet_temp_Frac":
        case "HCU_Frac_Dew_Point":
        case "HCU_NH4Cl_Rate":
        case "AqueousDewPoint":
        case "AmbientTemp":
        case "DewPoint":
        case "TCRvs.aq.DewPoint":
        case "DeltaT":
            return (value * 9) / 5 + 32;
        case "Throughput":
            return value * 0.0353107;
        case "ViscosityLastMonth":
        case "Viscosity":
            return value * 10.7639;
        case "NominalVelocity":
        case "VelocityLastMonth":
        case "SG_Velocity":
        case "Velocity":
            return value * 3.28084;
        case "PipeDiameter":
        case "SmokePointm":
            return value * 3.28084;
        case "NominalPressure":
        case "Pressure":
        case "ReidVapourPressurePsi":
        case "SG_Pressure":
        case "HCU_H2_Partial_Pressure":
        case "HCU_Tube_Side_dP":
            return value * 14.5038;
        case "HCU_Water_Wash_Flow_Rate":
        case "HCU_Water_Inj_Rate":
            return value * 0.264172;
        case "HCU_Inorganic_Chloride":
            return value * 0.264172;
        case "HCU_Hydrogen_Flow":
        case "HCU_H2_Flow":
            return value * 35.3147;
        default:
            return value;
    }
};

export const getConvertValue = (name, value) => {
    switch (name) {
        case "DensityLastMonth":
        case "DensityLastWeek":
        case "Density":
            return value * 0.119;
        case "AnilinePointC":
        case "CloudPointC":
        case "FlashPointC":
        case "FreezePointC":
        case "PourPointC":
        case "SofteningPointC":
        case "Temperature":
        case "TemperatureLastWeek":
        case "NominalTemperature":
        case "HCU_Temperature":
        case "HCU_Fractionator_Temp":
        case "HCU_H2_tube_temp":
        case "HCU_Water_Pump_Temp":
        case "HCU_Outlet_Temp":
        case "HCU_Reactor_Temp":
        case "HCU_Heater_Outlet_temp":
        case "HCU_Stack_Temp_B":
        case "HCU_Tubeskin_temp":
        case "HCU_Lean_Amine_A":
        case "HCU_Lean_Amine_B":
        case "HCU_Stack_Temp_A":
        case "HCU_REAC_Outlet_Temp":
        case "HCU_HPS_Temp":
        case "HCU_Skin_Temp":
        case "HCU_Feed_Outlet_temp":
        case "HCU_Feed_Drum_Temp":
        case "HCU_Heater_stack_temp":
        case "HCU_Preheat_Temp":
        case "HCU_Temp_Bottoms_A":
        case "HCU_Temp_Bottoms_B":
        case "HCU_Feed_Inlet_temp_Frac":
        case "HCU_Frac_Dew_Point":
        case "HCU_NH4Cl_Rate":
        case "AqueousDewPoint":
        case "AmbientTemp":
        case "DewPoint":
        case "TCRvs.aq.DewPoint":
        case "DeltaT":
            return ((value - 32) * 5) / 9;
        case "Throughput":
            return value * 28.32;
        case "ViscosityLastMonth":
        case "Viscosity":
            return value * 0.092903;
        case "NominalVelocity":
        case "VelocityLastMonth":
        case "Velocity":
            return value * 0.3048;
        case "PipeDiameter":
        case "SmokePointm":
            return value * 0.3048;
        case "NominalPressure":
        case "Pressure":
        case "ReidVapourPressurePsi":
        case "SG_Pressure":
        case "HCU_H2_Partial_Pressure":
        case "HCU_Tube_Side_dP":
            return value * 0.0689476;
        case "HCU_Water_Wash_Flow_Rate":
        case "HCU_Water_Inj_Rate":
            return value * 3.78541;
        case "HCU_Inorganic_Chloride":
            return value * 3.78541;
        case "HCU_Hydrogen_Flow":
        case "HCU_H2_Flow":
            return value * 28.3168;
        default:
            return value;
    }
};


export const getNumericBase = (value, units) => {
    if (units) {
        value = value * 10.7639;
    }
    value = value.toExponential();
    const [base, _] = value.toString().split('e');
    const num = +base;
    return +num.toFixed(2)
}

export const getPowerExponent = (value, units) => {
    if (units) {
        value = value * 10.7639;
    }
    value = value.toExponential();
    const [_, exponent] = value.toString().split('e');
    return exponent
}

export const convertToDecimal = (number, exponent) => {
    return number * Math.pow(10, exponent);
}


export const decimalRound = (value, feature) => {
    if (value !== 0 && value.toFixed(3) === '0.000' && !PERCENTAGE_FEATURE.includes(feature)) {
        const p = Math.abs(Math.floor(Math.log10(value)));
        return value.toFixed(p);
    } else {
        return value.toFixed(3)
    }
};

export function calculateStandardDeviation(min, max, avg, count, median) {

    // Calculate the variance
    const varianceSum = count * Math.pow(avg - median, 2);
    const variance = varianceSum / (count - 1);

    // Compute the standard deviation
    const standardDeviation = Math.sqrt(variance);

    return standardDeviation;
}